import moment from "moment";
import Order, { MyOrders, OrderStatus } from "../../models/order/order.model";
import { Collections, CollectionsClass } from "../../utils/firestore/collections";
import { handleErrors } from "../../utils/firestore/handleErrors";
import { AppDispatch } from "../store";
import * as OrderReducer from "./reducer";
import { collection, doc, getDoc, getDocs, limit, query, setDoc, updateDoc, where } from "firebase/firestore";

class OrderAction {

    static getOrders = (
        userId: string,
        month: number,
        year: number,
        dispatch: AppDispatch
    ) => {
        dispatch(OrderReducer.setIsLoading());
        const docRef = doc(CollectionsClass.instance, Collections.USER_ORDERS, `user_${userId}_${month}_${year}`);
        getDoc(docRef)
            .then(res => {
                const data = res.data() as MyOrders | undefined;
                if (data?.orders?.length) {
                    const sorted = [...data.orders].sort((a, b) =>
                        moment(b.created_at, 'DD-MM-YYYY HH:mm:ss').valueOf() - moment(a.created_at, 'DD-MM-YYYY HH:mm:ss').valueOf()
                    );
                    dispatch(OrderReducer.getOrdersSuccess(sorted));
                } else dispatch(OrderReducer.getOrdersSuccess([]));
            })
            .catch(e => dispatch(OrderReducer.setError(handleErrors(e))));
    }

    static createOrder = (
        order: Order,
        dispatch: AppDispatch
    ) => {
        dispatch(OrderReducer.setIsLoading());
        const orderDocRef = doc(CollectionsClass.instance, Collections.ORDERS, `order_${order.id}_${order.sender.id}`);
        const month = moment().month();
        const year = moment().year();
        setDoc(orderDocRef, order)
            .then(() => {
                const userOrdersRef = doc(CollectionsClass.instance, Collections.USER_ORDERS, `user_${order.sender.id}_${month}_${year}`);
                return getDoc(userOrdersRef);
            })
            .then(res => {
                const data = res.data() as MyOrders | null;
                const orders = data?.orders ? [...data.orders, order] : [order];
                const userOrdersRef = doc(CollectionsClass.instance, Collections.USER_ORDERS, `user_${order.sender.id}_${month}_${year}`);
                return setDoc(userOrdersRef, { orders });
            })
            .then(() => dispatch(OrderReducer.createOrderSuccess()))
            .catch(e => dispatch(OrderReducer.setError(handleErrors(e))));
    }

    static getOrdersByStatus = (dispatch: AppDispatch, status: OrderStatus) => {
        dispatch(OrderReducer.setAdminOrdersLoading());
        const q = query(
            collection(CollectionsClass.instance, Collections.ORDERS),
            where("status", "==", status),
            limit(10)
        );
        getDocs(q)
            .then((snapshot) => {
                const orders: (Order & { _docId?: string })[] = [];
                snapshot.docs.forEach((d) => {
                    const data = d.data() as Order;
                    if (data && data.id) orders.push({ ...data, _docId: d.id });
                });
                const sorted = orders.sort((a, b) =>
                    moment(b.created_at, "DD-MM-YYYY HH:mm:ss").valueOf() - moment(a.created_at, "DD-MM-YYYY HH:mm:ss").valueOf()
                );
                dispatch(OrderReducer.setAdminOrdersSuccess(sorted));
            })
            .catch((e) => dispatch(OrderReducer.setAdminOrdersError(handleErrors(e))));
    };

    static updateOrderStatus = (
        order: Order & { _docId?: string },
        status: OrderStatus,
        dispatch: AppDispatch,
        currentFilterStatus: OrderStatus
    ) => {
        dispatch(OrderReducer.setAdminOrdersLoading());
        const docId = order._docId ?? (order.sender ? `order_${order.id}_${order.sender.id}` : null);
        if (!docId) {
            dispatch(OrderReducer.setAdminOrdersError("Porosia nuk ka të dhëna të mjaftueshme për përditësim."));
            return;
        }
        const orderDocRef = doc(CollectionsClass.instance, Collections.ORDERS, docId);
        updateDoc(orderDocRef, { status })
            .then(() => OrderAction.getOrdersByStatus(dispatch, currentFilterStatus))
            .catch((e) => dispatch(OrderReducer.setAdminOrdersError(handleErrors(e))));
    };

    static clearState = (
        dispatch: AppDispatch
    ) => {
        dispatch(OrderReducer.clearState());
    }
}

export default OrderAction;